import { render, staticRenderFns } from "./BaseField.vue?vue&type=template&id=7af4f0dc"
import script from "./BaseField.vue?vue&type=script&lang=js"
export * from "./BaseField.vue?vue&type=script&lang=js"
import style0 from "./BaseField.vue?vue&type=style&index=0&id=7af4f0dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports